export class StructEntity {
  id: number;
  typeValue: string;
}

export enum StructEntityEnum {
  Public = 'Publicly Owned Corporations',
  PublicSEC = 'Publicly Owned Corporations - SEC audit'
}
